import { bblApi } from 'api/bbl'
import { clientApi } from 'api/client'
import { emptySplitApi as portalApi } from 'api/emptyApi'
import { resetBBLArchiveFilters } from 'Modules/Boardwork/DocumentArchive/BblArchive/BblArchiveSlice'
import { resetBoardArchiveFilters } from 'Modules/Boardwork/DocumentArchive/BoardArchive/BoardArchiveSlice'
import { fetchSubleaseSettingsRequested } from 'Modules/Boardwork/Tasks/Sublease/shared/store/sublease'
import { resetBudgetState } from 'Modules/Economy/Budget/shared/store/budgetSlice'
import { COMMITTEES_RESET } from 'Modules/HousingAssociation/BoardAndCommittees/shared/store/committees/actionTypes'
import { LOCAL_STORAGE_CLIENT_ID } from 'shared/constants/localStorageVariables'
import { setActiveClientIdStarted, setActiveClientId } from '.'
import { BOARD_FETCH_REQUESTED } from '../board/actionTypes'
import { EMAILS_SET_FILTERS } from '../communication/emails/actionTypes'
import { SMS_SET_FILTERS } from '../communication/smsMessages/actionTypes'
import loanApi from '../economy/loan/loan.service'
import { emptySplitApi } from '../emptyApi'
import menuApi from '../menu/menu.service'
import { AppDispatch } from '../store'
import terminologyApi from '../terminology/terminology.service'

export const setActiveClient = async (
  dispatch: AppDispatch,
  clientId?: string
) => {
  if (!clientId) return

  const createAction = (type: string) => ({ type, payload: clientId })

  dispatch(setActiveClientIdStarted())

  localStorage.setItem(LOCAL_STORAGE_CLIENT_ID, clientId)

  await dispatch(menuApi.endpoints.getMenu.initiate(clientId))

  dispatch(createAction(BOARD_FETCH_REQUESTED))
  dispatch(createAction(COMMITTEES_RESET))

  dispatch(loanApi.endpoints.getPendingInterestRateChanges.initiate(clientId))
  dispatch(terminologyApi.endpoints.getTerminology.initiate(clientId))

  dispatch(fetchSubleaseSettingsRequested(clientId))

  dispatch({
    type: EMAILS_SET_FILTERS,
    payload: {
      labelId: '',
      onlyUnread: false,
      dates: {
        received: { from: undefined, to: undefined },
        sent: { from: undefined, to: undefined },
        deleted: { from: undefined, to: undefined },
        processed: { from: undefined, to: undefined },
      },
    },
  })
  dispatch({
    type: SMS_SET_FILTERS,
    payload: { labelId: '' },
  })

  dispatch(setActiveClientId(clientId))
  dispatch(resetBudgetState())
  dispatch(resetBoardArchiveFilters())
  dispatch(resetBBLArchiveFilters())

  dispatch(portalApi.util.resetApiState())
  dispatch(emptySplitApi.util.resetApiState())

  await Promise.all([
    dispatch(bblApi.endpoints.getBbl.initiate()),
    dispatch(clientApi.endpoints.getClientsById.initiate({ id: clientId })),
    dispatch(
      clientApi.endpoints.getClientsByIdSettings.initiate({ id: clientId })
    ),
  ])
}
